module.exports = __webpack_public_path__ + "img/bg.47b3dc6c.png";